import React, { useState } from 'react';
import API_BASE_URL from '../Config';

import { useNavigate } from 'react-router-dom';
function Login() {

    const navigate = useNavigate();
    const [whatsapp_number, setWhatsapp] = useState("");
    // const [phone_number, setPhoneNumber] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
      e.preventDefault();
      setLoading(true);
      try {
        const response = await fetch(`${API_BASE_URL}/api/login`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({whatsapp_number:"+971"+whatsapp_number}),
        });
        const data = await response.json();
        if (data.status === 1) {
          localStorage.setItem("pendingUser", JSON.stringify(data.response.user));
          navigate("/verify-otp");
          // Save token in localStorage
          // localStorage.setItem("token", data.response.token);
          // Redirect to dashboard
        } else {
          setError(data.error);
        }
      } catch (err) {
        setError("Failed to login");
      } finally {
        setLoading(false);
      }
    };

    return (
        <div>
          <div>
            <div className="home_three_container">        
            <div>
              {/*breadcrumbs area start*/}
              <div className="breadcrumbs_area">
                <div className="container">   
                  <div className="row">
                    <div className="col-12">
                      <div className="breadcrumb_content">
                        <h3>Login</h3>
                        <ul>
                          <li><a href="/">home</a></li>
                          <li>Login</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>         
              </div>
              {/*breadcrumbs area end*/}
              {/* customer login start */}
              <div className="customer_login">
                <div className="container">
                  <div className="row">
                    {/*login area start*/}
                    <div className="col-lg-6 col-md-6">
                      <div className="account_form">
                        <h2>login</h2>
                         {/* error box */}
                          {error && (
                            <div style={{ background: "#ffe6e6",  color: "#cc0000", padding: "10px", borderRadius: "6px", marginBottom: "15px", fontWeight: "500", }}>
                              {error}
                            </div>
                          )}
                        <form onSubmit={handleSubmit}>
                          <p>
                          <span style={{ display: "block", marginBottom: "5px" }}>WhatsApp Number *</span>

                          <div style={{ display: "flex", alignItems: "center" }}>
                            <span style={{
                              padding: "8px 10px",
                              background: "#8169ff",
                              color: "#fff",
                              border: "1px solid #ccc",
                              borderRight: "none"
                            }}>
                              +971
                            </span>

                            <input
                              type="number"
                              value={whatsapp_number}
                              onChange={(e) => setWhatsapp(e.target.value)}
                              placeholder="501234567"
                              style={{ flex: 1 }}
                              required
                            />
                          </div>
                        </p>

                        
                          <div className="login_submit">
                           
                            <div className="login_submit">
                              <button type="submit" disabled={loading}>
                                {loading ? "Logging in..." : "Login"}
                              </button>
                            </div>
                            

                          </div>
                        </form>
                      </div>    
                    </div>
                    {/*login area start*/}
                    {/*register area start*/}
                    <div className="col-lg-6 col-md-6">
                      <div className="account_form register">
                        <h2>Register</h2>
                          <p> Please download our application </p>
                          <div>
                            <center>
                              <img src="/assets/images/fj_download_logo.png" alt="qr-code" height={120} width={120} />
                            </center>
                          </div>
                      </div>    
                    </div>
                  </div>
                </div>    
              </div>
            </div>
            </div>

          </div>
        </div>
    )
}
export default Login;
